// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.
//
// FRONT-END-ONLY SEED DATA (Daily/Compliance). Ported from the mockup's
// seedRoutines(); maintenance tasks authored in the same shape.
// See docs/design/hardcoded-frontend-data.md.

import type { Routine, MaintenanceTask } from '../types/alarm';

export const ROUTINES: Routine[] = [
  {
    id: 'SOP-12',
    name: 'UPS weekly self-test',
    cadence: 'Weekly · Mon 02:00',
    last: '02:00',
    runs: 3,
    result: 'UPS-1 / UPS-2 / UPS-3 passed',
    escalated: false,
    running: false,
    detail:
      'All three Vertiv Liebert modules completed their battery and inverter self-test with no faults.',
  },
  {
    id: 'SOP-03',
    name: 'Cooling loop ΔT check',
    cadence: 'Hourly',
    last: '14:00',
    runs: 15,
    result: 'Data Hall A / B ΔT nominal',
    escalated: false,
    running: false,
    detail: 'Supply/return ΔT across both halls within the 10–14 °F target band.',
  },
  {
    id: 'SOP-21',
    name: 'Leak detection sweep',
    cadence: 'Every 2h',
    last: '14:00',
    runs: 7,
    result: 'No leaks detected',
    escalated: false,
    running: false,
    detail: 'Rope sensors under both CRAH loops and the CW headers report dry.',
  },
  {
    id: 'SOP-08',
    name: 'Generator fuel & auto-start',
    cadence: 'Daily · 03:00',
    last: '03:00',
    runs: 1,
    result: 'Fuel 96% · auto-start OK',
    escalated: false,
    running: false,
    detail: 'Standby generator completed its no-load auto-start test; fuel polishing nominal.',
  },
  {
    id: 'SOP-15',
    name: 'Fire suppression panel poll',
    cadence: 'Every 6h',
    last: '12:00',
    runs: 3,
    result: 'Panels healthy',
    escalated: false,
    running: false,
    detail: 'VESDA and clean-agent panels report normal supervisory state.',
  },
  {
    id: 'SOP-30',
    name: 'Rack inlet temp scan',
    cadence: 'Every 15 min',
    last: '08:48',
    runs: 58,
    result: '1 reading promoted to alarm (A-14)',
    escalated: true,
    alarmRef: 'ALM-4450',
    running: false,
    detail:
      '57 of 58 scans clear. Rack A-14 exceeded the inlet advisory for three consecutive scans and was promoted to alarm ALM-4450.',
  },
  {
    id: 'SOP-05',
    name: 'BMS comms heartbeat',
    cadence: 'Every 5 min',
    last: '14:32',
    runs: 170,
    result: 'All controllers responding',
    escalated: false,
    running: true,
    detail: 'Every BMS controller and CRAH/PDU gateway answered its last poll.',
  },
];

export const MAINTENANCE_TASKS: MaintenanceTask[] = [
  {
    id: 'WO-2214',
    title: 'Quarterly IR thermographic survey — Electrical Room A',
    dueLabel: '16:00',
    asset: 'Switchgear Bus-A / Bus-B',
    location: 'Electrical Room A',
    sev: 'P3',
  },
  {
    id: 'WO-2219',
    title: 'CRAH-2 belt & filter inspection',
    dueLabel: '09:00',
    asset: 'CRAH-2',
    location: 'Data Hall A',
  },
  {
    id: 'WO-2225',
    title: 'Battery Bank 2 string 3 replacement (follow-up to ALM-4468)',
    dueLabel: '14:00',
    asset: 'UPS-2 Vertiv Liebert',
    location: 'UPS Room B',
    sev: 'P2',
  },
];
